import React from 'react';
import './PrivacyPage.css';

const PrivacyPage = () => {
  return (
    <div className="privacy-container">
      <div className="privacy-content">
        
        {/* Hero Section */}
        <div className="privacy-hero">
          <h1>Privacy Policy</h1>
          <p>Ganpati Wallpaper — Last updated: August 13, 2026</p>
        </div>

        {/* Highlight Guarantee Banner */}
        <div className="privacy-guarantee-card">
          <div className="privacy-guarantee-icon">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
              <polyline points="9 12 11 14 15 10"></polyline>
            </svg>
          </div>
          <div className="privacy-guarantee-text">
            <h3>100% Privacy Protection & Zero Data Collection</h3>
            <p>
              Ganpati Wallpaper is committed to protecting user privacy. We <strong>do not collect, store, transmit, or share</strong> any personal information, location data, device identifiers, or usage analytics.
            </p>
          </div>
        </div>

        {/* Detailed Privacy Policy Card */}
        <div className="privacy-card">
          
          <h2>1. Overview & Commitment</h2>
          <p>
            This Privacy Policy governs the use of the <strong>Ganpati Wallpaper</strong> mobile application ("Application", "Service", "We", "Us", or "Our").
          </p>
          <p>
            We believe that your privacy is a fundamental right. Our application is built exclusively to allow devotees and users to view, download, and set high-resolution Lord Ganesha wallpapers without compromising their personal privacy or tracking their digital footprint.
          </p>

          <h2>2. Zero Personal Data Collection</h2>
          <p>
            We do not require, collect, store, or process any personal data from you when using the Service.
          </p>
          <ul>
            <li>
              <strong>No Account Required:</strong> You can use the full functionality of the app without registering, logging in, or creating an account.
            </li>
            <li>
              <strong>No Personal Identifiers:</strong> We do not ask for or collect your name, email address, phone number, physical address, or contacts.
            </li>
            <li>
              <strong>No Financial Information:</strong> The app is 100% free to use. We do not collect credit card, bank account, or payment details.
            </li>
          </ul>

          <h2>3. Zero Usage & Tracking Data</h2>
          <p>
            We strictly enforce a zero-tracking policy within Ganpati Wallpaper:
          </p>
          <ul>
            <li>
              <strong>No Analytics Tracking:</strong> We do not use third-party analytics services (such as Google Analytics, Firebase Analytics, or Mixpanel) to monitor user behavior, screen views, or click events.
            </li>
            <li>
              <strong>No Device Identifiers:</strong> We do not collect device serial numbers, IMEI numbers, Advertising IDs (IDFA/GAID), MAC addresses, or IP addresses.
            </li>
            <li>
              <strong>No Location Tracking:</strong> We do not request or track your geographic location (GPS, Wi-Fi, or cellular location).
            </li>
          </ul>

          <h2>4. On-Device Local Permissions</h2>
          <p>
            To enable core functionality such as saving wallpapers or setting them on your device, the Application may request basic local permissions:
          </p>
          <ul>
            <li>
              <strong>Storage / Photos Permission:</strong> Used solely to allow you to save Lord Ganesha wallpapers to your local device gallery or set them as your Home/Lock screen background.
            </li>
            <li>
              <strong>Local Processing Only:</strong> All saved wallpaper images remain 100% local to your device. No images, files, or media from your device are ever uploaded or transmitted to external servers.
            </li>
          </ul>

          <h2>5. Third-Party Services & Links</h2>
          <p>
            Ganpati Wallpaper does not sell, rent, or share any data with third-party advertisers, data brokers, or marketing partners.
          </p>
          <p>
            If the Application contains external links (such as support email links or website links), clicking them will redirect you to external platforms. We recommend reviewing the privacy policies of any third-party sites you visit, as we do not control external web services.
          </p>

          <h2>6. Children's Privacy</h2>
          <p>
            Our Service is safe for users of all ages, including children under 13. Because We collect no personal data whatsoever, Ganpati Wallpaper strictly complies with global child privacy regulations, including the Children’s Online Privacy Protection Act (COPPA).
          </p>

          <h2>7. Security & Data Retention</h2>
          <p>
            Because We do not collect, store, or maintain any personal data or usage logs on external servers, there is no risk of server-side data breaches, leaks, or unauthorized access to your personal information.
          </p>

          <h2>8. Changes to This Privacy Policy</h2>
          <p>
            We may update our Privacy Policy from time to time. Any updates will be posted directly on this page with a updated "Last updated" date at the top of the policy. We encourage you to review this page periodically.
          </p>

          <h2>9. Contact Us</h2>
          <p>
            If you have any questions, suggestions, or concerns regarding this Privacy Policy, please feel free to reach out to us:
          </p>
          <ul>
            <li>
              <strong>By Email:</strong> <a href="mailto:ganeshglive@gmail.com">ganeshglive@gmail.com</a>
            </li>
            <li>
              <strong>App Name:</strong> Ganpati Wallpaper HD
            </li>
          </ul>

        </div>

      </div>
    </div>
  );
};

export default PrivacyPage;